import { render } from "./createDetails.vue?vue&type=template&id=c4a6425a"
import script from "./createDetails.vue?vue&type=script&lang=js"
export * from "./createDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__